import { ActionTree } from 'vuex/types/index'
import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { Invite, InvitesState, InviteResource } from './invites.types'
import { setIncludedResources } from '~/utils/store'

const actions: ActionTree<InvitesState, RootState> = {
  async fetchInvite ({ commit }, id) {
    const { data, included } = await this.$sohoApi.get<InviteResource>(`${SohoModel.Invite}/${id}`, { include: ['guest_list'] })

    if (included) {
      setIncludedResources(included, commit)
    }

    commit('SET_INVITE', data)

    return data
  },

  async updateInvite({ commit }, params) {
    const { data } = await this.$sohoApi.patch<Invite>(SohoModel.Invite, { type: SohoModel.Invite, ...params }, undefined, true)

    commit('SET_INVITE', data)

    return data
  }
}

export default actions
